import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { NEW_ARRIVALS_SUBCATEGORY_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { localizedUrlWithQueryParams } from "@faire/retailer-visitor-shared/lib/pathUtils";
import { CategoryPagePaths } from "@faire/retailer-visitor-shared/paths/CategoryPage";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore";
import { findClosestActiveCategoryUrlIdsByPathIdentifier } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore/findByPathIdentifier";
import { findActiveCategoryByUrlIds } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore/findByUrlId";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";
import { SearchMakersWithFiltersSortBy } from "@faire/web-api--source/indigofair/data/SearchMakersWithFiltersSortBy";
import { SortOrder } from "@faire/web-api--source/indigofair/data/SortOrder";
var buildCategoryPath = function(param, categories, routingContext) {
    var category = param.category, sort_order = param.sort_order, sort_by = param.sort_by, filter_keys = param.filter_keys;
    var queryParams = {};
    if (category === undefined) {
        return undefined;
    }
    var _findClosestActiveCategoryUrlIdsByPathIdentifier;
    var categoryUrlIds = (_findClosestActiveCategoryUrlIdsByPathIdentifier = findClosestActiveCategoryUrlIdsByPathIdentifier(category, categories)) !== null && _findClosestActiveCategoryUrlIdsByPathIdentifier !== void 0 ? _findClosestActiveCategoryUrlIdsByPathIdentifier : [
        {
            id: category
        }
    ];
    if (sort_by === SearchMakersWithFiltersSortBy.FIRST_ACTIVE_AT && sort_order === SortOrder.DESC && // Show New arrivals for C1 or C2
    findActiveCategoryByUrlIds(_to_consumable_array(categoryUrlIds.map(function(urlId) {
        return urlId.id;
    })).concat([
        NEW_ARRIVALS_SUBCATEGORY_URL_ID
    ]), categories)) {
        // If filters values have specific values (first_active_at) + sort descending
        // route to new arrivals subcategory if it exists
        categoryUrlIds.push({
            id: NEW_ARRIVALS_SUBCATEGORY_URL_ID
        });
    } else {
        if (sort_by) {
            queryParams.sort_by = sort_by;
        }
        if (sort_order) {
            queryParams.sort_order = sort_order;
        }
    }
    if (filter_keys !== undefined && filter_keys.length > 0) {
        queryParams.filters = filter_keys.join(",");
    }
    return CategoryPagePaths.index({
        categoryUrlIds: categoryUrlIds,
        queryParams: queryParams,
        routingContext: routingContext
    });
};
export var HOMEPAGE_RECENTLY_SEARCHED_QUERY_PRODUCTS_CAROUSEL_EVENT_NAME = "homepage_recently_searched_query_products";
/**
 * Used to link to category page from dynamic Category Carousels and other dynamic links
 */ export var useLayoutElementCarouselCtaLink = function(layoutElement, requestId) {
    var categories = useCategoryStore().categories;
    var routingContext = useRetailerRoutingContext();
    var cta_link_to_search_products = layoutElement.cta_link_to_search_products, cta_link_to_search_makers = layoutElement.cta_link_to_search_makers, cta_link = layoutElement.cta_link, on_click_event_name = layoutElement.on_click_event_name;
    var newLocal = cta_link && on_click_event_name === HOMEPAGE_RECENTLY_SEARCHED_QUERY_PRODUCTS_CAROUSEL_EVENT_NAME;
    if (newLocal) {
        return localizedUrlWithQueryParams(cta_link, {
            refType: ISearchRequestReferrer.SearchRequestReferrerType.HOMEPAGE_NEW_PRODUCTS_FROM_RECENT_SEARCH,
            refReqId: requestId
        });
    } else if (cta_link_to_search_products) {
        return buildCategoryPath(cta_link_to_search_products, categories, routingContext);
    } else if (cta_link_to_search_makers) {
        return buildCategoryPath(cta_link_to_search_makers, categories, routingContext);
    } else {
        return cta_link;
    }
};
